import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IContentDefinition,
  PLAN_DETAILS_EXIT_FEES,
  PLAN_DETAILS_KEY,
  PLAN_DETAILS_PLAN_PERIOD,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
  PLAN_DETAILS_RATE_TYPE,
} from '../../typings';
import { PlanKeyDetailsModal } from './PlanKeyDetailsModal';
import { estimatesDialog, IEstimatesDialog } from './estimatesDialog';
import { getKeyDetailsContentIcon } from '../utils/PlanMetaHelper';
import React from 'react';
import { EVModal } from './generalElectricVehicle';
import { GreenOptionModal } from './genericGreenOption';
import { BYOBattery } from './BYOBatteryModal';

// TODO: Refactor plans that inline identical keyDetails to use defaultKeyDetails/ongoingKeyDetails instead.
// 12-month: businessGoVariable, businessSolarBoost, originBusinessUsageAdvantage,
//   affinityVariableEPlus, GreenerForBusiness, homeSupport, originBatteryMaximiser, originBatteryStarter,
//   originBusinessSunshineSpecial, originEmployeeGoVariable, originSolarBoostWithBatteryLite, originSolarPartnerPlus
// Ongoing: basic, businessBasic
export const defaultKeyDetails = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable',
    modalContent: PlanKeyDetailsModal,
    // for plan card redesign in sales-monorepo only
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable rates',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    // for plan card redesign in sales-monorepo only
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
    // for plan card redesign in sales-monorepo only
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
];

export const ongoingKeyDetails = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable rates',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue:
      PLAN_DETAILS_PLAN_PERIOD.Ongoing + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: 'Ongoing contract',
  },
];

export const ongoingBenefitPeriodKeyDetails = ongoingKeyDetails.map((detail) =>
  detail.contentKey === DETAILS_CONTENT_KEYS.BenefitPeriod
    ? { ...detail, contentDescription: 'Ongoing benefit period' }
    : detail
);

export const defaultPlanDetailsKey = [
  {
    contentKey: PLAN_DETAILS_KEY.RateType,
    contentValue: PLAN_DETAILS_RATE_TYPE.Flexible,
  },
  {
    contentKey: PLAN_DETAILS_KEY.ExitFees,
    contentValue: PLAN_DETAILS_EXIT_FEES.None,
  },
  {
    contentKey: PLAN_DETAILS_KEY.PlanPeriod,
    contentValue:
      PLAN_DETAILS_PLAN_PERIOD.Months12 + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
  },
];

export const gasKeyDetailsAddons = [];

export const defaultBusinessGasDetailsAddons = [];

export const evKeyDetailsAddons = [
  {
    contentKey: DETAILS_CONTENT_KEYS.EVAddOn,
    contentValue: 'Register',
    modalContent: EVModal,
    // for plan card redesign in sales-monorepo only (IconElectricVehicle)
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EVAddOn),
    contentDescription: 'EV charging - 8c/ kWh',
  },
];

export const greenPowerKeyDetailsAddons = [
  {
    contentKey: DETAILS_CONTENT_KEYS.GreenOptions,
    contentValue: 'Register',
    modalContent: GreenOptionModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.GreenOptions),
    contentDescription: '100% GreenPower electricity',
  },
];

export const electricityKeyDetailsAddons = [...greenPowerKeyDetailsAddons, ...evKeyDetailsAddons];

export const dualKeyDetailsAddons = [...gasKeyDetailsAddons, ...electricityKeyDetailsAddons];

export const businessDualKeyDetailsAddons = [...defaultBusinessGasDetailsAddons];

export const businessElectricityKeyDetailsAddons = [];

export const byoBatteryAddon = {
  contentKey: DETAILS_CONTENT_KEYS.BYOBattery,
  contentValue: 'Register',
  modalContent: BYOBattery,
  // for plan card redesign in sales-monorepo only
  contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BYOBattery),
  contentDescription: 'BYO battery for extra value',
};

export const defaultEstimatesDialog = ({
  onlineCreditAmount = undefined,
  customerType,
}: IEstimatesDialog = {}): IContentDefinition<React.ReactElement> => {
  return {
    contents: [
      {
        data: estimatesDialog({ onlineCreditAmount, customerType }),
        tags: ['state:qld'],
      },
      {
        data: estimatesDialog({ customerType }),
        tags: [],
      },
    ],
  };
};
